import React, { Component, Fragment } from 'react';
import { Field, reduxForm } from 'redux-form';

import TextInput from './../../Inputs/TextInput';
import { required, minLength, matchPass } from '../../../../utils/validators';
import Button from './../../Inputs/Button';
import i18n from '../../../../i18n/i18n.js';

const minLength8 = minLength(8, 'password');

let SetNewPasswordForm = props => {
    const lng = props.auth.lng;

    return (
        <Fragment>
            <header>
                <div className="headline">
                    <h4>
                        <a
                            className="currentpage"
                            href="#"
                            style={{
                                borderBottom:
                                    '2px solid ' +
                                    props.branding.paywall_primary_color,
                            }}
                        >
                            {i18n.t('modal_enter_your_new_password', { lng })}
                        </a>
                    </h4>
                </div>
            </header>
            <section id="userdetails">
                {!props.auth.setPassErrorMsg && (
                    <p
                        style={{
                            border: '0.5px solid rgb(82, 206, 176)',
                            padding: '5px',
                            width: '80%',
                            margin: 'auto',
                        }}
                        className="inplayer-form-error "
                    >
                        <span className={`ipic_warning notif-icon`} />
                        Please check your email and insert the received token
                        below.
                    </p>
                )}
                <div className="formelements">
                    <form className="labelholder" onSubmit={props.handleSubmit}>
                        <div className="labelholder">
                            <Field
                                component={TextInput}
                                id="token"
                                type="text"
                                name="token"
                                label={i18n.t('placeholder_token', { lng })}
                                validate={[required]}
                                handleFocus={props.handleFocus}
                                active={
                                    props.name === 'token'
                                        ? props.active
                                        : false
                                }
                                primaryColor={
                                    props.branding.paywall_primary_color
                                }
                                iconName="diamond"
                            />
                        </div>
                        <div className="labelholder">
                            <Field
                                component={TextInput}
                                id="newpassword"
                                type="password"
                                name="newpassword"
                                label={i18n.t('new_password', { lng })}
                                validate={[required, minLength8]}
                                handleFocus={props.handleFocus}
                                active={
                                    props.name === 'newpassword'
                                        ? props.active
                                        : false
                                }
                                primaryColor={
                                    props.branding.paywall_primary_color
                                }
                            />
                        </div>
                        <div className="labelholder repeatpsw">
                            <Field
                                component={TextInput}
                                id="repassword"
                                type="password"
                                name="repassword"
                                label={i18n.t('repeat_new_password', { lng })}
                                autoComplete="off"
                                validate={[required, matchPass]}
                                handleFocus={props.handleFocus}
                                active={
                                    props.name === 'repassword'
                                        ? props.active
                                        : false
                                }
                                primaryColor={
                                    props.branding.paywall_primary_color
                                }
                                iconName="reload"
                            />
                        </div>
                        <div className="buttonholder">
                            <a
                                className="back changepass"
                                onClick={props.closeModal}
                            >
                                {i18n.t('cancel', { lng })}
                            </a>
                            <Button
                                text={i18n.t('set', { lng })}
                                backgroundColor={
                                    props.branding.paywall_buttons_bg_color
                                }
                                touched={
                                    props.params && props.params.anyTouched
                                }
                                errors={
                                    props.params && props.params.syncErrors
                                        ? true
                                        : false
                                }
                                isLoading={props.auth.isLoadingButton}
                            />
                        </div>
                    </form>
                </div>
            </section>
        </Fragment>
    );
};

export default reduxForm({
    form: 'newPasswordForm',
})(SetNewPasswordForm);



// WEBPACK FOOTER //
// ./src/ui/components/Forms/ForgotPassword/SetNewPassword.js